import React from 'react'
import DrawingsIndex from '../features/drawings'
function Instructions() {
  return (
    <DrawingsIndex />
  )
}

export default Instructions